import {
  type UserGroupListItem,
  UserGroupMapper,
} from "@/models/user-group.model";
import type { GetUserGroupListPaginatedParams } from "@/spz-api/model";
import { getUserGroupListPaginated } from "@/spz-api/user-groups/user-groups";
import type { IUserGroupRepository } from "../interfaces/user-group-repository.interface";

export class UserGroupRepository implements IUserGroupRepository {
  async getUserGroups(
    params: GetUserGroupListPaginatedParams,
  ): Promise<UserGroupListItem[]> {
    const response = await getUserGroupListPaginated(params);
    return UserGroupMapper.toListItems(response.data);
  }
}
